document.addEventListener("DOMContentLoaded", function () {
	document.getElementById("image-banner")?.addEventListener("click", () => {
		window.location.href = "/collections/all";
	});
});
	// Show more/less description in PDP
document.querySelectorAll('.toggle-description')?.forEach(function(button) {
  button.addEventListener('click', function() {
    if (button.textContent === 'Show More') {
      button.textContent = 'Show Less';
    } else {
      button.textContent = 'Show More';
    }
    document.querySelector('.product__description').classList.toggle('expanded');
  });
});


